// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { NewsletterState, GetNewslettersParams } from "@/types/admin/newsletter-contact-type";
// import { newsletterService } from "@/services/system-admin/admin-data.service";

// const initialState: NewsletterState = {
//   newsletters: [],
//   loading: false,
//   error: null,
//   totalCount: 0,
//   currentPage: 1,
//   pageSize: 20,
// };

// export const fetchNewsletters = createAsyncThunk(
//   "newsletters/fetchNewsletters",
//   async (params: GetNewslettersParams) => {
//     const response = await newsletterService.getNewsletters(params);
//     return { ...response, page: params.page, pageSize: params.pageSize };
//   }
// );

// const newsletterSlice = createSlice({
//   name: "newsletters",
//   initialState,
//   reducers: {
//     clearError: (state) => { state.error = null; },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchNewsletters.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchNewsletters.fulfilled, (state, action) => {
//         state.loading = false;
//         const list = action.payload.items || action.payload.data || action.payload.result?.items || [];
//         state.newsletters = list;
//         state.currentPage = action.payload.page || 1;
//         state.pageSize = action.payload.pageSize || 20;
//         if (list.length > 0) {
//           state.totalCount = list[0].totalCount || action.payload.totalCount || action.payload.result?.totalCount || 0;
//         } else {
//           state.totalCount = action.payload.totalCount || action.payload.result?.totalCount || 0;
//         }
//       })
//       .addCase(fetchNewsletters.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.error.message || "Failed to fetch newsletters";
//       });
//   },
// });

// export const { clearError } = newsletterSlice.actions;
// export default newsletterSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { NewsletterState, GetNewslettersParams } from "@/types/admin/newsletter-contact-type";
import { newsletterService } from "@/services/system-admin/admin-data.service";

const initialState: NewsletterState = {
  newsletters: [],
  loading: false,
  error: null,
  totalCount: 0,
  currentPage: 1,
  pageSize: 20,
};

export const fetchNewsletters = createAsyncThunk(
  "newsletters/fetchNewsletters",
  async (params: GetNewslettersParams) => {
    const response = await newsletterService.getNewsletters(params);
    return { ...response, page: params.page, pageSize: params.pageSize };
  }
);

const newsletterSlice = createSlice({
  name: "newsletters",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNewsletters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNewsletters.fulfilled, (state, action) => {
        state.loading = false;
        const list = action.payload.result?.items || [];
        state.newsletters = list;
        state.currentPage = action.payload.page || 1;
        state.pageSize = action.payload.pageSize || 20;
        // ✅ totalRecordCount lives inside each item
        state.totalCount = list[0]?.totalRecordCount || 0;
      })
      .addCase(fetchNewsletters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch newsletters";
      });
  },
});

export const { clearError } = newsletterSlice.actions;
export default newsletterSlice.reducer;